import { render, staticRenderFns } from "./MyScheduledNotifications.vue?vue&type=template&id=4f1f8ce6"
import script from "./MyScheduledNotifications.vue?vue&type=script&lang=js"
export * from "./MyScheduledNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports